// Canonical size / length options and display formatting for service pricing
// combinations and task pricing rows. Kept in one place so the service editor,
// the task-pricing editor, and the read-only tables can't drift apart.

export const SIZE_OPTIONS: string[] = ['XXS', 'XS', 'S', 'SM', 'M', 'L', 'XL', 'JUMBO'];

export const LENGTH_OPTIONS: string[] = [
	'SHOULDER',
	'BRA',
	'MID_BACK',
	'WAIST',
	'BUTT',
	'HIP',
	'THIGH',
	'KNEE',
];

const SIZE_LABELS: Record<string, string> = {
	XXS: 'XXS',
	XS: 'XS',
	S: 'Small',
	SM: 'SM',
	M: 'Medium',
	L: 'Large',
	XL: 'XL',
	JUMBO: 'Jumbo',
};

/** Human label for a size code, e.g. "M" → "Medium". Unknown codes pass through. */
export const formatSize = (size: string): string => SIZE_LABELS[size] || size;

/** Human label for a length code, e.g. "MID_BACK" → "Mid Back". */
export const formatLength = (length: string): string =>
	length
		.split('_')
		.map(word => word.charAt(0) + word.slice(1).toLowerCase())
		.join(' ');
